import { createSelector } from "reselect";

export const getHttpMessage = (state) => state.httpMessages;

export const getHttpMessageData = createSelector(getHttpMessage, (httpMessage) => {
  httpMessage = httpMessage.toObject();

  return {
    ...httpMessage,
    additional: httpMessage.additional.toArray(),
  };
});

export const getStorageOverusedError = createSelector(getHttpMessage, (data) => {
  const { stack = {} } = data.toJS();
  return stack.storageOverused;
});
